import "./spinner.css";

export const Spinner = () => {
  return <div className="spinner "></div>;
};
